// Форматирование чисел в js
function numberFormat(number, decimals, decPoint, thousandsSep) {
    decimals = decimals || 0;
    number = parseFloat(number);

    if (!decPoint || !thousandsSep) {
        decPoint = '.';
        thousandsSep = ',';
    }

    var roundedNumber = Math.round(Math.abs(number) * ('1e' + decimals)) + '';
    var numbersString = decimals ? roundedNumber.slice(0, decimals * -1) : roundedNumber;
    var decimalsString = decimals ? roundedNumber.slice(decimals * -1) : '';
    var formattedNumber = "";

    while (numbersString.length > 3) {
        formattedNumber += thousandsSep + numbersString.slice(-3)
        numbersString = numbersString.slice(0, -3);
    }

    return (number < 0 ? '-' : '') + numbersString + formattedNumber + (decimalsString ? (decPoint + decimalsString) : '');
}

$(document).ready(function () {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    // Смена картинки на главной странице при наведении курсора на айтем в слайдере
    const $mainImageContainer = $('.first-block .js-image-container');
    $('.js-door-models .item').hover(function () {
        let bigImage = $(this).attr('data-big-image');

        $mainImageContainer.css('background-image', 'url(' + bigImage + ')');
    });

    // Маска телефона
    $('.js-phone').mask('+7 (000) 000 00 00');

    /**
     * Табы характеристик
     */
    $('.js-tab-switch').click(function (ev) {
        ev.preventDefault();

        var $target = $($(this).attr('data-target')),
            $tabsContainer = $('.js-characteristics').find('.tab-content'),
            $switchers = $('.js-characteristics').find('a');

        $switchers.removeClass('active');
        $(this).addClass('active');

        $tabsContainer.find('.tab').hide();
        $target.fadeIn();
    });

    $('.js-tab-switch').first().trigger('click');

    /**
     * AJAX формы
     */
    $('.js-form').each(function () {
        $(this).submit(function (ev) {
            ev.preventDefault();
            var $form = $(this);

            $.ajax({
                url: $form.attr('action'),
                method: $form.attr('method') ? $form.attr('method') : 'GET',
                data: $form.serialize(),
                dataType: 'json',
                beforeSend: function () {
                    $form.addClass('ajax-loading');
                    $form.find('button').attr('disabled', 'disabled');
                },
                success: function (response) {
                    $form.removeClass('ajax-loading');
                    $form.find('button').removeAttr('disabled');

                    if (response.success) {
                        $.fancybox.close();

                        $('#ajax-result-form').find('h2').text(response.message);

                        $.fancybox.open({
                            src: '#ajax-result-form',
                            type: 'inline'
                        });

                        // Цели Метрики
                        switch ($form.attr('id')) {
                            case 'send-order-form':
                                yaCounter47957747.reachGoal('orderform');
                                break;

                            case 'free-measure-form':
                                yaCounter47957747.reachGoal('zamer');
                                break;
                        }
                    }
                }
            });
        });
    });

    /**
     * КОНФИГУРАТОР
     *
     * @type {number}
     */
    var currentPrice = 0,
        $config = $('.configurator'),
        $configForm = $config.find('form'),
        basePrice = parseInt($config.data('price'), 10),
        originalPrice = parseInt($config.data('price'), 10),
        discount = parseInt($config.data('discount'), 10);

    $config.find('input[name=side]').change(function () {
        setSide($(this).filter(':checked').val());
    });

    $config.find('input').change(function () {
        calculatePrice();
    });

    $config.find('.js-get-config').click(function () {
        getConfig();
    });

    $config.find('.js-print').click(function () {
        printConfig();
    });

    $config.find('.js-buy').click(function () {
        buy();
    });

    $config.find('.js-param a').click(function () {
        $(this).parents('.js-param').toggleClass('active');
    });

    function setSide(val) {
        if (val == 1) {
            $config.find('.images img').removeClass('right');
        } else {
            $config.find('.images img').addClass('right');
        }
    }

    function setPrice() {
        $config.find('.current-price').html(numberFormat(currentPrice, 0, '.', ' '));

        if (discount) {
            $config.find('.old-price-wrapper').show();
            $config.find('.old-price').html(numberFormat(originalPrice, 0, '.', ' '));
        } else {
            $config.find('.old-price-wrapper').hide();
        }
    }

    function calculatePrice() {
        $('.zoom').trigger('zoom.destroy');

        currentPrice = basePrice;

        $configForm.find('input:checked').each((i, el) => {
            currentPrice += parseInt($(el).data('price'), 10);

            if ($(el).data('outer-img') || $(el).data('inner-img')) {
                if ($(el).data('outer-img')) {
                    $configForm.find('.out img').attr('src', $(el).data('outer-img'));
                    $configForm.find('.out.zoom').zoom(
                        {
                            url: $(el).data('outer-img'),
                        }
                    );
                }

                if ($(el).data('inner-img')) {
                    $configForm.find('.in img').attr('src', $(el).data('inner-img'));
                    $configForm.find('.in.zoom').zoom(
                        {
                            url: $(el).data('inner-img'),
                        }
                    );
                }
            }
        });

        originalPrice = currentPrice;
        currentPrice -= discount;

        setPrice();
    }

    function generatePdfConfig(type) {
        var allParams = $configForm.find('.param'),
            configuration = {},
            $currentElement,
            $currentParams,
            paramTitle,
            paramValue,
            mainGroupValue;

        configuration.doorModelId = $configForm.find('.door-model-id').first().val();
        configuration.doorModelName = $configForm.find('.door-model-name').first().val();
        configuration.outImg = $configForm.find('.out img').first().attr('src');
        configuration.inImg = $configForm.find('.in img').first().attr('src');
        configuration.price = $configForm.find('.current-price').text();
        configuration.config = [];

        allParams.each((i, el) => {
            mainGroupValue = '';
            $currentParams = {};
            $currentParams.params = [];

            $currentElement = $(el);
            $currentParams.name = $.trim($currentElement.find('.block-head').text());

            $currentElement.find('.main-group input:checked').each(function (j, mainGroup) {
                mainGroupValue += $(mainGroup).data('value') + '<br>';
            });
            $currentParams.value = mainGroupValue;

            $currentElement.find('.group').each((k, group) => {
                paramTitle = $(group).find('.title').text();
                paramValue = $(group).find('input:checked').data('value');

                $currentParams.params.push({
                    'name': paramTitle,
                    'value': paramValue
                });
            });

            configuration.config.push($currentParams)
        });

        configuration.right = $configForm.find('input[name=side]:checked').val() == 2;

        switch (type) {
            case 'print':
                $.fancybox.open({
                    src: '#pdf-config',
                    type: 'inline'
                });
                break;

            case 'get':
                $.fancybox.open({
                    src: '#pdf-get-config',
                    type: 'inline'
                });
                break;

            case 'buy':
                $.fancybox.open({
                    src: '#buy-door',
                    type: 'inline'
                });
                break;
        }

        $.ajax({
            url: '/pdf',
            method: 'POST',
            data: {
                'config': configuration
            },
            dataType: 'json',
            success: function (response) {
                switch (type) {
                    case 'print':
                        $('#pdf-config').find('.js-pdf-notice').hide();
                        $('#pdf-config').find('.js-pdf-content').show().find('a').attr('href', response.url);
                        break;

                    case 'get':
                        $('#pdf-get-config').find('.js-pdf-notice').hide();
                        $('#pdf-get-config').find('.js-pdf-content').show().find('.js-pdf-link').val(response.url);
                        break;

                    case 'buy':
                        $('#buy-door').find('.js-pdf-notice').hide();
                        $('#buy-door').find('.js-pdf-content').show().find('.js-pdf-link').val(response.url);
                        break;
                }
            }
        });
    }

    function printConfig() {
        generatePdfConfig('print');
    }

    function getConfig() {
        generatePdfConfig('get');
    }

    function buy() {
        generatePdfConfig('buy');
    }

    setSide(1);
    calculatePrice();

    /**
     * Клик на кнопки мессенджеров (только для mydoor-spb)
     */
    /*$('.js-wa, .js-vi').click(function (ev) {
        ev.preventDefault();

        gtag_report_conversion($(this).attr('href'));
    })*/

    $(window).scroll(function () {
        var aTop = 0;

        if ($('.first-block').length) {
            aTop = $('.first-block').height() + 83;
        } else {
            aTop = $('.promo').height() + 83;
        }

        if ($(this).scrollTop() >= aTop) {
            $('header').fadeOut(100);
        } else {
            $('header').fadeIn(100);
        }
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js